import { render, staticRenderFns } from "./DialogBulkDelete.vue?vue&type=template&id=4aa232a4&"
import script from "./DialogBulkDelete.vue?vue&type=script&lang=js&"
export * from "./DialogBulkDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports